import { render, staticRenderFns } from "./CriteriaForm.vue?vue&type=template&id=0bcd4f04&scoped=true&"
import script from "./CriteriaForm.vue?vue&type=script&lang=js&"
export * from "./CriteriaForm.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaForm.vue?vue&type=style&index=0&id=0bcd4f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd4f04",
  null
  
)

export default component.exports